const ConfigVars = Object.freeze({
    mSecBeforeRedirect: 10000,
})
export default ConfigVars